import React from "react";

type SubmitButtonProps = {
  label: string;
  isSubmitDisabled?: boolean;
};

export const SubmitButton: React.FC<SubmitButtonProps> = ({
  label,
  isSubmitDisabled = false,
}) => {
  return (
    <button
      className="button button_primary--black button_primary--small button--expanded spacer"
      disabled={isSubmitDisabled}
      type="submit"
    >
      {label}
    </button>
  );
};
